import { showAlert } from "./alerts.js";

console.log("hello from manageProducts.js");

const deleteProduct = async (currentStoreId, productId, productName) => {
  try {
    await axios.delete(
      `/api/v1/stores/${currentStoreId}/products/${productId}`,
    );
    alert(
      `${productName} supprimé avec succès!, cliquez sur "OK" pour recharger !`,
    );
    location.reload();
  } catch (err) {
    console.log(">>>>>> Erreur Suppression  : ", err.response.data);
    alert(err.response.data.message);
  }
};

const addProduct = async (currentStoreId, data) => {
  try {
    const res = await axios.post(
      `/api/v1/stores/${currentStoreId}/products`,
      data,
    );
    if (res.data.status === "success") {
      showAlert("success", "Success", "Produit ajouté avec succès !");
      setTimeout(() => {
        location.assign("/addproduct");
      }, 1000);
    }
  } catch (err) {
    console.log(err);
    showAlert("danger", "Alert", err.response.data);
  }
};

const updateProduct = async (currentStoreId, productId, data) => {
  // console.log(
  //   "Updating product with data (raw entries):",
  //   Array.from(data.entries())
  // );
  // return;
  try {
    const res = await axios.patch(
      `/api/v1/stores/${currentStoreId}/products/${productId}`,
      data,
    );
    if (res.data.status === "success") {
      showAlert("success", "Success", "Produit mis à jour avec succès !");
      setTimeout(() => {
        location.reload();
      }, 2000);
    }
  } catch (err) {
    showAlert("danger", "Alert", err.response.data);
  }
};

const activationHandler = async (currentStoreId, productId, value) => {
  try {
    const res = await axios.patch(
      `/api/v1/stores/${currentStoreId}/products/${productId}`,
      {
        active: value,
      },
    );
    if (res.data.status === "success") {
      location.reload();
    }
  } catch (err) {
    console.log(">>>>>> error activation : ", err.response.data.message);
    alert(err.response.data.message);
  }
};

const generateBoostOrder = async function (
  type,
  user,
  store,
  product,
  pricingId,
) {
  try {
    const res = await axios.post(`/api/v1/orders`, {
      type,
      user,
      store,
      product,
      pricingId,
    });
    if (res.data.status === "success") {
      showAlert(
        "success",
        "Success !",
        "Votre commande a été placée avec succès, veuillez contacter le service client pour confirmation !",
      );
      location.reload();
    }
  } catch (err) {
    console.log(">>>>>> erreur de Suppression : ", err.response.data.message);
    alert(err.response.data.message);
  }
};

const addProductForm = document.getElementById("add-product-form");
const updateProductBtn = $(".update-product-btn");
const modalProductId = $("#modal-product-id");
const dBtn = $(".delete-product-btn");

const storeActivateProductBtn = $(".store-activate-product-btn");
const storeBlockProductBtn = $(".store-inactive-product-btn");
const boostProductBtn = $(".boost-product-btn");

if (storeActivateProductBtn) {
  storeActivateProductBtn.on("click", function () {
    const conf = confirm("Êtes-vous sûr de vouloir inactiver le produit? ");
    const productId = $(this).data("id");
    const currentStoreId = $(this).data("store");
    if (conf) {
      activationHandler(currentStoreId, productId, 0);
    }
  });
}

if (storeBlockProductBtn) {
  storeBlockProductBtn.on("click", function () {
    const conf = confirm(
      "Êtes-vous sûr que vous souhaitez activer ce produit ? ",
    );
    const currentStoreId = $(this).data("store");
    const productId = $(this).data("id");
    if (conf) {
      activationHandler(currentStoreId, productId, 1);
    }
  });
}

if (addProductForm) {
  addProductForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    showAlert("primary", "Yay !", "Ajout de produit, veuillez patienter ...");

    // Get form values
    const name = document.getElementById("productname").value;
    const smallDescription = document.getElementById("smallDescription").value;
    const price = document.getElementById("price").value;
    const devise = document.getElementById("devise").value;
    const stock = document.getElementById("stock").value;
    const category = document.getElementById("productCategory").value;
    const city = document.getElementById("productCity").value;
    const municipality = document.getElementById("productMunicipality").value;
    const tags = Array.from(
      document.querySelectorAll(".input.product-tags"),
      (e) => e.value,
    );
    const brand = document.getElementById("brand").value;
    const manufacturer = document.getElementById("manufacturer").value;
    const description = document.getElementById("productDescription").value;
    const currentStoreId = document.getElementById("storeId").value;

    // Get thumbnail (required)
    const thumbnail = document.getElementById("file-upload-productThumbnail")
      .files[0];

    // Get additional images (optional, multiple)
    const additionalImages = document.getElementById(
      "file-upload-productImages",
    ).files;

    // Validate required fields
    if (!name) {
      showAlert("danger", "Erreur !", "Le nom du produit est requis");
      return;
    }

    if (!price) {
      showAlert("danger", "Erreur !", "Le prix du produit est requis");
      return;
    }

    if (!thumbnail) {
      showAlert(
        "danger",
        "Erreur !",
        "L'image principale (thumbnail) est requise",
      );
      return;
    }

    const data = new FormData();

    // Append basic product data
    data.append("name", name);
    data.append("smallDescription", smallDescription);
    data.append("price", price);
    data.append("devise", devise);
    data.append("stock", stock);
    data.append("category", category);
    data.append("city", city);
    data.append("municipality", municipality);

    // Append tags (keep your existing logic)
    if (tags[0]) {
      data.append("tags", tags[0]);
    } else {
      data.append("tags", "Kinshasa");
    }
    if (tags[1]) {
      data.append("tags", tags[1]);
    } else {
      data.append("tags", "Qualité");
    }
    if (tags[2]) {
      data.append("tags", tags[2]);
    } else {
      data.append("tags", "Super");
    }
    if (tags[3]) {
      data.append("tags", tags[3]);
    } else {
      data.append("tags", "Original");
    }

    data.append("brand", brand);
    data.append("manufacturer", manufacturer);
    data.append("description", description);

    // Append thumbnail (required)
    data.append("thumbnail", thumbnail);

    // Append additional images (optional - 0 to unlimited)
    if (additionalImages && additionalImages.length > 0) {
      // Append all selected images with field name "images"
      for (let i = 0; i < additionalImages.length; i++) {
        data.append("images", additionalImages[i]);
      }
    }
    // Note: If no additional images are selected, we don't append anything
    // The backend will handle this and use default image

    // Log for debugging
    console.log("Submitting product with:");
    console.log("- Name:", name);
    console.log("- Price:", price);
    console.log("- Thumbnail file:", thumbnail ? thumbnail.name : "none");
    console.log(
      "- Additional images:",
      additionalImages ? additionalImages.length : 0,
    );

    // Call your existing addProduct function
    addProduct(currentStoreId, data);
  });
}

if (updateProductBtn) {
  updateProductBtn.on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const productId = $(this).data("id");
    const currentStoreId = $(this).data("store");
    const name = $(this).data("name");
    const smallDescription = $(this).data("smalldescription");
    const price = $(this).data("price");
    const devise = $(this).data("devise");
    const stock = $(this).data("stock");
    const category = $(this).data("category");
    const city = $(this).data("city");
    const municipality = $(this).data("municipality");
    const tags = $(this).data("tags");
    const brand = $(this).data("brand");
    const manufacturer = $(this).data("manufacturer");
    const description = $(this).data("description");
    const thumbnail = $(this).data("thumbnail");

    // Get images array - parse if it's a JSON string
    let images = $(this).data("images");
    if (typeof images === "string") {
      try {
        images = JSON.parse(images);
      } catch (error) {
        console.error("Error parsing images data:", error);
        images = [];
      }
    }

    // Ensure images is an array
    if (!Array.isArray(images)) {
      images = [];
    }

    // Populate form fields
    $("#update-product-modal #title").text(`Modifier Produit : ${name}`);
    $("#update-product-modal #name").val(name);
    $("#update-product-modal #smallDescription").val(smallDescription);
    $("#update-product-modal #price").val(price);
    $("#update-product-modal #devise #dev-option1").val(devise).text(devise);
    $("#update-product-modal #stock").val(stock);
    $("#update-product-modal #category #cat-option1").text(category);
    $("#update-product-modal #city #city-option1").text(city);
    $("#update-product-modal #municipality #mun-option1").text(municipality);
    $("#update-product-modal .tag1").val(tags.split(",")[0] || "");
    $("#update-product-modal .tag2").val(tags.split(",")[1] || "");
    $("#update-product-modal .tag3").val(tags.split(",")[2] || "");
    $("#update-product-modal .tag4").val(tags.split(",")[3] || "");
    $("#update-product-modal #manufacturer").val(manufacturer);
    $("#update-product-modal #brand").val(brand);
    $("#update-product-modal #description").val(description);
    $("#update-product-modal #thumbnail").attr(
      "src",
      `/assets/img/${thumbnail}`,
    );

    // Initialize the image preview with existing images
    initializeUpdateProductImages(images);

    // Store product ID for later use
    $("#update-product-modal").data("productId", productId);
    $("#update-product-modal").data("storeId", currentStoreId);

    // Set up the update button click handler
    $("#modal-update-product-btn")
      .off("click")
      .on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        // alert("Clicked !");
        updateProductHandler(productId, currentStoreId);
      });
  });
}

// Global array for update modal images
let updateProductImages = [];

// Function to initialize existing images in update modal
function initializeUpdateProductImages(imagesArray) {
  updateProductImages = []; // Reset the array

  const previewContainer = document.getElementById(
    "product-images-preview-update",
  );
  previewContainer.innerHTML = "";

  // Reset the file input
  const fileInput = document.getElementById("file-upload-productImages-update");
  if (fileInput) {
    fileInput.value = "";
  }

  // Add each existing image to the preview
  if (imagesArray && imagesArray.length > 0) {
    imagesArray.forEach((imageFilename, index) => {
      if (imageFilename && imageFilename.trim() !== "") {
        addExistingImageToPreview(imageFilename, index + 1);
      }
    });
  }

  updateUpdateProductImageCount();
}

// Function to add an existing image to the preview
function addExistingImageToPreview(imageFilename, position) {
  const previewContainer = document.getElementById(
    "product-images-preview-update",
  );

  // Create a unique ID for this image
  const fileId = `existing-${Date.now()}-${Math.random()}`;

  // Store in our global array
  updateProductImages.push({
    id: fileId,
    filename: imageFilename,
    isExisting: true,
    position: position,
  });

  // Create preview element
  const previewDiv = document.createElement("div");
  previewDiv.className = "preview-item";
  previewDiv.dataset.fileId = fileId;
  previewDiv.style.position = "relative";
  previewDiv.style.width = "200px";
  previewDiv.style.margin = "10px";
  previewDiv.style.order = position;

  // Create image
  const img = document.createElement("img");
  img.id = `preview-update-img-${fileId}`;
  img.className = "file-name";
  img.style.width = "100%";
  img.style.height = "150px";
  img.style.objectFit = "cover";
  img.style.borderRadius = "8px";
  img.style.border = "2px solid #4CAF50";
  img.alt = `Image ${position}`;
  img.src = `/assets/img/${imageFilename}`;

  // Create remove button
  const removeBtn = document.createElement("button");
  removeBtn.type = "button";
  removeBtn.className = "delete is-small";
  removeBtn.style.position = "absolute";
  removeBtn.style.top = "5px";
  removeBtn.style.right = "5px";
  removeBtn.style.backgroundColor = "red";
  removeBtn.style.borderRadius = "50%";
  removeBtn.innerHTML = "&times;";
  removeBtn.onclick = function () {
    removeUpdateProductImage(fileId);
  };

  // Create info div
  const info = document.createElement("div");
  info.className = "is-size-7 mt-2 has-text-centered";
  info.innerHTML = `
    <span class="tag is-success is-light is-small">Existante</span><br>
    ${
      imageFilename.length > 20
        ? imageFilename.substring(0, 20) + "..."
        : imageFilename
    }
  `;

  // Create position badge
  const positionBadge = document.createElement("span");
  positionBadge.className = "tag is-dark is-small";
  positionBadge.style.position = "absolute";
  positionBadge.style.top = "5px";
  positionBadge.style.left = "5px";
  positionBadge.textContent = position;
  positionBadge.style.fontSize = "0.7rem";

  previewDiv.appendChild(img);
  previewDiv.appendChild(positionBadge);
  previewDiv.appendChild(removeBtn);
  previewDiv.appendChild(info);

  previewContainer.appendChild(previewDiv);
}

// Function to remove an image from update preview
function removeUpdateProductImage(fileId) {
  // Remove from our array
  const index = updateProductImages.findIndex((img) => img.id === fileId);
  if (index !== -1) {
    updateProductImages.splice(index, 1);
  }

  // Remove from DOM
  const previewDiv = document.querySelector(`[data-file-id="${fileId}"]`);
  if (previewDiv) {
    previewDiv.remove();
  }

  // Update positions and count
  updateUpdateProductPositions();
  updateUpdateProductImageCount();
}

// Function to update positions of all images
function updateUpdateProductPositions() {
  const previewItems = document.querySelectorAll(
    "#product-images-preview-update .preview-item",
  );

  previewItems.forEach((item, index) => {
    const positionBadge = item.querySelector(".tag.is-dark");
    if (positionBadge) {
      positionBadge.textContent = index + 1;
    }

    // Update order for CSS
    item.style.order = index + 1;

    // Update position in our array
    const fileId = item.dataset.fileId;
    const imgIndex = updateProductImages.findIndex((img) => img.id === fileId);
    if (imgIndex !== -1) {
      updateProductImages[imgIndex].position = index + 1;
    }
  });
}

// Function to update image count display
function updateUpdateProductImageCount() {
  let countDisplay = document.getElementById("update-image-count-display");

  if (!countDisplay) {
    const fileCta = document.querySelector("#update-product-modal .file-cta");
    if (fileCta) {
      countDisplay = document.createElement("span");
      countDisplay.id = "update-image-count-display";
      countDisplay.className = "ml-2 tag is-info is-light";
      fileCta.appendChild(countDisplay);
    }
  }

  if (countDisplay) {
    countDisplay.textContent = `${updateProductImages.length}/20 images`;
  }
}

// Function to handle new image uploads in update modal
function handleUpdateProductImageUpload(e) {
  const fileInput = e.target;
  const newFiles = fileInput.files;
  const previewContainer = document.getElementById(
    "product-images-preview-update",
  );

  // Check if we have space for more images
  const maxImages = 20;
  const availableSlots = maxImages - updateProductImages.length;

  if (availableSlots <= 0) {
    // Show warning
    const warning = document.createElement("div");
    warning.className = "notification is-warning is-light mt-2";
    warning.style.width = "100%";
    warning.innerHTML = `<p>Limite de 20 images atteinte. Vous ne pouvez pas ajouter plus d'images.</p>`;

    // Remove any existing warning
    const existingWarning = previewContainer.querySelector(
      ".notification.is-warning",
    );
    if (existingWarning) {
      existingWarning.remove();
    }

    previewContainer.appendChild(warning);
    return;
  }

  // Process new files
  const filesToProcess = Array.from(newFiles).slice(0, availableSlots);

  filesToProcess.forEach((file, index) => {
    // Check if it's an image
    if (!file.type.match(/image.*/)) {
      console.warn(`File ${file.name} is not an image`);
      return;
    }

    // Add to our array
    const fileId = `new-${Date.now()}-${Math.random()}`;
    updateProductImages.push({
      id: fileId,
      file: file,
      isExisting: false,
      isNew: true,
      position: updateProductImages.length + 1,
    });

    // Create preview
    const reader = new FileReader();
    reader.onload = function (e) {
      addNewImageToPreview(
        fileId,
        file.name,
        e.target.result,
        updateProductImages.length,
      );
    };
    reader.readAsDataURL(file);
  });

  // Show warning if some files were ignored
  if (newFiles.length > availableSlots) {
    const warning = document.createElement("div");
    warning.className = "notification is-warning is-light mt-2";
    warning.style.width = "100%";
    warning.innerHTML = `<p>Maximum ${maxImages} images autorisées. ${
      newFiles.length - availableSlots
    } image(s) ignorée(s).</p>`;

    const existingWarning = previewContainer.querySelector(
      ".notification.is-warning",
    );
    if (existingWarning) {
      existingWarning.remove();
    }

    previewContainer.appendChild(warning);
  }

  updateUpdateProductImageCount();
}

// Function to add a new image to preview
function addNewImageToPreview(fileId, fileName, dataUrl, position) {
  const previewContainer = document.getElementById(
    "product-images-preview-update",
  );

  const previewDiv = document.createElement("div");
  previewDiv.className = "preview-item";
  previewDiv.dataset.fileId = fileId;
  previewDiv.style.position = "relative";
  previewDiv.style.width = "200px";
  previewDiv.style.margin = "10px";
  previewDiv.style.order = position;
  previewDiv.style.animation = "fadeIn 0.3s ease";

  // Create image
  const img = document.createElement("img");
  img.id = `preview-update-img-${fileId}`;
  img.className = "file-name";
  img.style.width = "100%";
  img.style.height = "150px";
  img.style.objectFit = "cover";
  img.style.borderRadius = "8px";
  img.style.border = "2px solid #2196F3";
  img.alt = fileName;
  img.src = dataUrl;

  // Create remove button
  const removeBtn = document.createElement("button");
  removeBtn.type = "button";
  removeBtn.className = "delete is-small";
  removeBtn.style.position = "absolute";
  removeBtn.style.top = "5px";
  removeBtn.style.right = "5px";
  removeBtn.style.backgroundColor = "red";
  removeBtn.style.borderRadius = "50%";
  removeBtn.innerHTML = "&times;";
  removeBtn.onclick = function () {
    removeUpdateProductImage(fileId);
  };

  // Create info div
  const info = document.createElement("div");
  info.className = "is-size-7 mt-2 has-text-centered";
  info.innerHTML = `
    <span class="tag is-info is-light is-small">Nouvelle</span><br>
    ${fileName.length > 20 ? fileName.substring(0, 20) + "..." : fileName}
  `;

  // Create position badge
  const positionBadge = document.createElement("span");
  positionBadge.className = "tag is-dark is-small";
  positionBadge.style.position = "absolute";
  positionBadge.style.top = "5px";
  positionBadge.style.left = "5px";
  positionBadge.textContent = position;
  positionBadge.style.fontSize = "0.7rem";

  previewDiv.appendChild(img);
  previewDiv.appendChild(positionBadge);
  previewDiv.appendChild(removeBtn);
  previewDiv.appendChild(info);

  previewContainer.appendChild(previewDiv);
}

// Function to handle the update product form submission
function updateProductHandler(productId, storeId) {
  showAlert("primary", "Yay !", "Updating product ...");

  const data = new FormData();

  // Get form values
  data.append("name", $("#update-product-modal #name").val());
  data.append(
    "smallDescription",
    $("#update-product-modal #smallDescription").val(),
  );
  data.append("price", $("#update-product-modal #price").val());
  data.append("devise", $("#update-product-modal #devise").val());
  data.append("stock", $("#update-product-modal #stock").val());
  data.append("category", $("#update-product-modal #category").val());
  data.append("city", $("#update-product-modal #city").val());
  data.append("municipality", $("#update-product-modal #municipality").val());
  data.append("tags", $("#update-product-modal .tag1").val());
  data.append("tags", $("#update-product-modal .tag2").val());
  data.append("tags", $("#update-product-modal .tag3").val());
  data.append("tags", $("#update-product-modal .tag4").val());
  data.append("brand", $("#update-product-modal #brand").val());
  data.append("manufacturer", $("#update-product-modal #manufacturer").val());
  data.append("description", $("#update-product-modal #description").val());

  // Get thumbnail
  const thumbnailFile = document.querySelector(
    "#update-product-modal #file-upload",
  ).files[0];
  if (thumbnailFile) {
    data.append("thumbnail", thumbnailFile);
  }

  // Add new images
  const newImages = updateProductImages
    .filter((img) => !img.isExisting && img.file)
    .map((img) => img.file);

  newImages.forEach((file) => {
    data.append("images", file);
  });

  // Add existing images that should be kept
  const existingImages = updateProductImages
    .filter((img) => img.isExisting)
    .map((img) => img.filename);

  existingImages.forEach((filename) => {
    data.append("images", filename);
  });

  // // Build a readable preview of the FormData (includes file names for File objects)
  // const formDataPreview = {};
  // for (const [key, value] of data.entries()) {
  //   if (value instanceof File) {
  //     // accumulate multiple files under same key as array of names
  //     if (formDataPreview[key]) {
  //       if (Array.isArray(formDataPreview[key])) {
  //         formDataPreview[key].push(value.name);
  //       } else {
  //         formDataPreview[key] = [formDataPreview[key], value.name];
  //       }
  //     } else {
  //       formDataPreview[key] = value.name;
  //     }
  //   } else {
  //     if (formDataPreview[key]) {
  //       if (Array.isArray(formDataPreview[key])) {
  //         formDataPreview[key].push(value);
  //       } else {
  //         formDataPreview[key] = [formDataPreview[key], value];
  //       }
  //     } else {
  //       formDataPreview[key] = value;
  //     }
  //   }
  // }

  // console.log("Updating product with data (preview):", formDataPreview);
  // // Also log raw entries for full inspection
  // console.log("Updating product raw entries:", Array.from(data.entries()));
  // return;
  // Call the update function
  updateProduct(storeId, productId, data);
}

// Set up event listener for the update modal image input
document.addEventListener("DOMContentLoaded", function () {
  const updateImageInput = document.getElementById(
    "file-upload-productImages-update",
  );

  if (updateImageInput) {
    // Remove any existing event listeners
    const newInput = updateImageInput.cloneNode(true);
    updateImageInput.parentNode.replaceChild(newInput, updateImageInput);

    // Add new event listener
    newInput.addEventListener("change", handleUpdateProductImageUpload);
  }
});

if (dBtn) {
  dBtn.on("click", function (e) {
    e.stopPropagation();
    const productId = $(this).data("id");
    const productName = $(this).data("name");
    const currentStoreId = $(this).data("store");
    modalProductId.text(productName);

    $("#modalDelBtn").one("click", function (e) {
      e.stopPropagation();
      deleteProduct(currentStoreId, productId, productName);
    });
  });
}

if (boostProductBtn) {
  boostProductBtn.on("click", function (e) {
    e.stopPropagation();
    const productId = $(this).data("id");
    const productName = $(this).data("name");
    const pricingId = $(this).data("boostid");
    const boostName = $(this).data("bname");
    const boostStamp = $(this).data("stamp");
    const boostPrice = $(this).data("price");
    const type = "boost";
    const store = $(this).data("store");
    const user = $(this).data("user");
    const boostLimit = $(this).data("limit");
    const boostDescription = $(this).data("description");
    const boostDuration = $(this).data("duration");

    $("#modal-boost-product-name").text(productName);
    $("#modal-boost-stamp").attr("src", "/assets/img/" + boostStamp);
    $("#modal-boost-description").text(boostDescription);

    $("#modalBoostBtn").one("click", function (e) {
      e.stopPropagation();
      generateBoostOrder(type, user, store, productId, pricingId);
    });
  });
}

// ------------------------------------------------------------
// Helpers
// ------------------------------------------------------------
const getVal = (id) => document.getElementById(id)?.value;
const alertSuccessReload = (msg) => {
  showAlert("success", "Success", msg);
  setTimeout(() => location.reload(), 1200);
};

// ------------------------------------------------------------
// API CALLS
// ------------------------------------------------------------
async function addProductReview(productId, productStore, review, rating) {
  try {
    const res = await axios.post(`/api/v1/products/${productId}/reviews`, {
      review,
      rating,
      productStore,
    });

    if (res.data.status === "success") {
      alertSuccessReload("Avis ajouté avec succès !");
    }
  } catch (err) {
    showAlert("danger", "Alert", err.response?.data || "Erreur serveur");
  }
}

async function updateProductReview(productId, reviewId, review, rating) {
  try {
    const res = await axios.patch(
      `/api/v1/products/${productId}/reviews/${reviewId}`,
      { review, rating },
    );

    if (res.data.status === "success") {
      alertSuccessReload("Avis mis à jour avec succès !");
    }
  } catch (err) {
    showAlert("danger", "Alert", err.response?.data || "Erreur serveur");
  }
}

async function deleteProductReview(productId, reviewId) {
  try {
    await axios.delete(`/api/v1/products/${productId}/reviews/${reviewId}`);
    alertSuccessReload("Avis supprimé avec succès !");
  } catch (err) {
    showAlert("danger", "Alert", err.response?.data || "Erreur serveur");
  }
}

async function adminDeleteProductReview(reviewId) {
  try {
    await axios.delete(`/api/v1/reviews/${reviewId}`);
    alertSuccessReload("Avis supprimé avec succès !");
  } catch (err) {
    showAlert("danger", "Alert", err.response?.data || "Erreur serveur");
  }
}

// ------------------------------------------------------------
// EVENT HANDLERS - Individual event listeners
// ------------------------------------------------------------

// Initialize all event listeners
function initEventListeners() {
  // ADD review button
  const addBtn = document.getElementById("add-product-review-btn");
  if (addBtn) {
    addBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (!getVal("productReview") || getVal("productReview").trim() === "") {
        console.log("getVal review:", getVal("productReview"));
        showAlert(
          "warnig",
          "Alert",
          "Le commentaire ne peut pas être vide. Veuillez réessayer.",
        );
        return;
      }
      showAlert("primary", "Yay !", "Ajout de votre avis...");

      addProductReview(
        getVal("productId"),
        getVal("productStore"),
        getVal("productReview"),
        getVal("product-rating"),
      );
    });
  }

  // UPDATE review button
  const updateBtn = document.getElementById("update-product-review-btn");
  if (updateBtn) {
    updateBtn.addEventListener("click", function (e) {
      e.preventDefault();
      showAlert("primary", "Yay !", "Modification de votre avis ...");

      updateProductReview(
        getVal("productId"),
        getVal("currentUserProductReviewId"),
        getVal("productReview"),
        getVal("product-rating"),
      );
    });
  }

  // DELETE review (user) button
  const deleteBtn = document.getElementById("delete-product-review-btn");
  if (deleteBtn) {
    deleteBtn.addEventListener("click", function (e) {
      e.preventDefault();
      showAlert("primary", "Yay !", "Suppression de votre avis...");

      deleteProductReview(
        getVal("productId"),
        getVal("currentUserProductReviewId"),
      );
    });
  }
}

// Event delegation for dynamically added admin delete buttons
// We attach a single listener to a parent container that exists on page load
const reviewsContainer =
  document.getElementById("reviews-container") ||
  document.querySelector(".reviews-table") ||
  document.body;

reviewsContainer.addEventListener("click", function (e) {
  // Check if the clicked element has the admin delete class
  if (e.target.classList.contains("admin-delete-product-review-btn")) {
    e.preventDefault();
    const reviewId = e.target.dataset.reviewId;
    // console.log("Admin delete review ID:", reviewId);
    // return;
    showAlert("primary", "Yay !", "Suppression de l'avis ...");
    adminDeleteProductReview(reviewId);
  }
});

// Initialize event listeners when DOM is loaded
document.addEventListener("DOMContentLoaded", initEventListeners);

// Re-initialize event listeners after AJAX content is loaded (if applicable)
if (typeof reinitializeComponents === "function") {
  // If you have a function that reloads content via AJAX, call initEventListeners there
  const originalReinitialize = reinitializeComponents;
  reinitializeComponents = function () {
    originalReinitialize();
    initEventListeners();
  };
}

// ============================================================
